import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVER_URL } from "../initalState"; // Note: Fix typo "initalState" to "initialState"

export const driverApi = createApi({
  reducerPath: "driver",
  baseQuery: fetchBaseQuery({
    // baseUrl: `${SERVER_URL}/qiktrack`,
    baseUrl: `${SERVER_URL}/qiktrack`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["driver"],
  endpoints: (builder) => ({
    getdriver: builder.query({
      query: ({ isApproved, page, limit, search, companyId }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;
        if (isApproved !== undefined && isApproved !== "") params.isApproved = isApproved; 
          if (companyId !== undefined && companyId !== ""&& companyId !== "all")
            params.companyId = companyId; // Note: Fix typo "comapny_id" to "company_id"
        console.log(params);
        return {
          url: `/get-driver`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["driver"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
     getMydriver: builder.query({
      query: ({ isApproved, page, limit, search, companyId }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;
        if (isApproved !== undefined && isApproved !== "") params.isApproved = isApproved; 
          if (companyId !== undefined && companyId !== ""&& companyId !== "all")
            params.companyId = companyId; // Note: Fix typo "comapny_id" to "company_id"
        console.log(params);
        return {
          url: `/get-mydriver`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["driver"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
    // Add a driver
    adddriver: builder.mutation({
      query: (data) => {
        console.log(data);
        return {
          url: "/create-driver",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["driver"], // Invalidate cache on mutation
    }),
       addMydriver: builder.mutation({
      query: (data) => {
        console.log(data);
        return {
          url: "/create-mydriver",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["driver"], // Invalidate cache on mutation
    }),
    updatedriver: builder.mutation({
      query: (data) => {
        return {
          url: `/update-driver/${data?._id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["driver"], // Invalidate cache on mutation
    }),
        updateMydriver: builder.mutation({
      query: (data) => {
        return {
          url: `/update-mydriver/${data?._id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["driver"], // Invalidate cache on mutation
    }),
    deletedriver: builder.mutation({
      query: ({ id }) => ({
        url: `/delete-driver/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["driver"], // Invalidate cache on mutation
    }),
        deleteMydriver: builder.mutation({
      query: ({ id }) => ({
        url: `/delete-mydriver/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["driver"], // Invalidate cache on mutation
    }),
  }),
});

export const {
  useGetdriverQuery,
  useAdddriverMutation,
  useUpdatedriverMutation,
  useDeletedriverMutation,
  useGetMydriverQuery,
  useAddMydriverMutation,
  useUpdateMydriverMutation,
  useDeleteMydriverMutation,
} = driverApi;
